// @core/api/endpoints/search/search.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SearchRequest,
  SearchResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Search across products
 * Performs full-text search across indexed entities. Supports filters, facets, highlighting, and optional federated search across peer platforms.
 */
export async function Search(
  data: SearchRequest,
  options?: RequestOptions
): Promise<SearchResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/search`;
  const requestOptions = options;
  return client.post<SearchResponse>(requestPath, data, requestOptions);
}
